export default "__VITE_ASSET__R8AU8h6W__"